// extracted by mini-css-extract-plugin
export default {"wrapper":"aE-z","response":"bE-z","error":"cE-z","disabled":"dE-z","buttons":"eE-z","feedbackQuestionSection":"fE-z","yesNoWrapper":"gE-z"};